import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AlmacenService } from 'src/app/services/api/almacen.service';
import { FileService } from 'src/app/services/api/file.service';
import { DialogAsignarEquiposFileComponent } from './dialog-asignar-equipos-file/dialog-asignar-equipos-file.component';

@Component({
  selector: 'app-asignar-equipos-file',
  templateUrl: './asignar-equipos-file.component.html',
  styleUrls: ['./asignar-equipos-file.component.css'],
})
export class AsignarEquiposFileComponent implements OnInit {
  items: any = [];

  displayedColumns: any[] = [
    'nombre',
    'marca',
    'modelo',
    'talla',
    'equiposAsignados',
    'editar',
  ];

  fileId: any = '';
  productId: any = '';

  dataSource: any;
  loading: boolean = true;

  file: any;
  productName: any;

  totalAssigned: any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private fileService: FileService,
    private route: ActivatedRoute,
    private router: Router,
    private almacenService: AlmacenService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.fileId = this.route.snapshot.paramMap.get('fileId');
    this.productId = this.route.snapshot.paramMap.get('productId');

    this.getFile();
    this.getProduct();
    this.getAllAgrupadoByFileAndProduct();
  }

  async getTotalAssigned(equipoId: string) {
    const data = await firstValueFrom(
      this.almacenService.getAllEgresoEquiposByFileAndProductIdAndEquipoId(
        this.fileId,
        this.productId,
        equipoId,
      ),
    );

    console.log(data);
    return data.getAllEgresoEquiposByFileAndProductIdAndEquipoId.length;
  }

  getFile() {
    this.fileService.getItineraryDetailed(this.fileId).subscribe((res: any) => {
      console.log(res);
      this.file = res.getItinerary;
    });
  }

  getProduct() {
    this.fileService.getProductById(this.productId).subscribe((res: any) => {
      console.log(res);
      this.productName = res.getProductById.nombre;
    });
  }

  getAllAgrupadoByFileAndProduct() {
    this.almacenService
      .getAllAgrupadoByFileAndProduct(this.fileId, this.productId)
      .subscribe(async (response) => {
        this.items = response.getAllAgrupadoByFileAndProduct;

        // this.items=this.items.filter((item:any)=>item.selected)

        console.log(this.items);

        await Promise.all(
          this.items.map(async (item: any) => {
            //console.log(item)
            item.totalAssigned = await this.getTotalAssigned(
              item.agrupadoInfo.equipoId,
            );
          }),
        );

        console.log('itemss', this.items);

        this.items = this.items.sort((a: any, b: any) =>
          a.agrupadoInfo?.nombreEquipo.localeCompare(
            b.agrupadoInfo?.nombreEquipo,
          ),
        );
        this.dataSource = new MatTableDataSource(this.items);
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      });
  }

  openDialogAsignarEquipo(item: any, i: number): void {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      item: item,
      file: this.file,
    };
    dialogConfig.width = '40rem';
    dialogConfig.height = '500px';

    let dialogRef = this.dialog.open(
      DialogAsignarEquiposFileComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log('closed');
      console.log(result);
      if (result !== null) {
        Object.assign(this.dataSource.data[i], {
          ...item,
          totalAssigned: result,
        });
        //this.getAllEquipos();
      }
    });
  }
}
